import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Typography from "../../atoms/Typography/Typography";
import { ImStarEmpty, ImStarFull, ImStarHalf } from "react-icons/im";

import "./Skill.scss";

const Skill = ({ level, children }) => {
  const getStars = (level) => {
    const stars = [];

    const max = 5;
    const halfLevel = level / 2;

    for (let i = 0; i < max; i++) {
      if (halfLevel - i > 0.5) {
        stars.push(<ImStarFull />);
      } else if (halfLevel - i === 0.5) {
        stars.push(<ImStarHalf />);
      } else {
        stars.push(<ImStarEmpty />);
      }
    }
    return stars;
  };

  return (
    <div className="skill">
      <Typography>{children}</Typography>
      <div>
        {getStars(level).map((star, index) => (
          <Fragment key={index}>{star}</Fragment>
        ))}
      </div>
    </div>
  );
};

const numberWithinTen = (props, propName, componentName) =>
  props[propName] &&
  typeof props[propName] === "number" &&
  (props[propName] < 0 || props[propName] > 10)
    ? new Error(`Invalid prop ${propName} supplied to ${componentName}.
    Validation failed.`)
    : null;

Skill.propTypes = {
  level: numberWithinTen,
  children: PropTypes.node.isRequired,
};

export default Skill;
